import { useMemo } from 'react'
import { useEvents } from '../../hooks/useEvents'
import type { EventListItem } from '../../types'

// Other NYMR events whose day-set intersects the proposed slot — the "event
// conflicts" surfaced on the Team panel and marked on the calendar. Excludes the
// event being planned and Idea-status events (same rule as CalendarContext).

export interface ForecastConflict { event: EventListItem; overlapDates: string[] }
export interface ForecastConflicts { conflicts: ForecastConflict[]; conflictDates: Set<string>; total: number }

export function useForecastConflicts(eventId: number, proposedDates: string[]): ForecastConflicts {
  const { data: events } = useEvents()
  return useMemo(() => {
    const proposedSet = new Set(proposedDates)
    const conflicts: ForecastConflict[] = []
    const conflictDates = new Set<string>()
    if (proposedSet.size === 0) return { conflicts, conflictDates, total: 0 }
    for (const ev of events ?? []) {
      if (ev.id === eventId || ev.status === 'Idea') continue
      const overlap: string[] = []
      for (const d of ev.dates ?? []) if (proposedSet.has(d)) { overlap.push(d); conflictDates.add(d) }
      if (overlap.length) { overlap.sort(); conflicts.push({ event: ev, overlapDates: overlap }) }
    }
    conflicts.sort((a, b) => (a.overlapDates[0] ?? '').localeCompare(b.overlapDates[0] ?? ''))
    return { conflicts, conflictDates, total: conflicts.length }
  }, [events, eventId, proposedDates])
}
